import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { colors, gradient, greys } from "@clockwise/web-commons/src/styles/color.styles";
import { weight } from "@clockwise/web-commons/src/styles/type.styles";
import { zIndexHomeNav } from "@clockwise/web-commons/src/styles/z-index-stack.styles";

export const container: CSSProperties = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  zIndex: zIndexHomeNav,
  display: "flex",
  height: 80,
  background: "white",
  borderBottom: `1px solid ${greys.paleGrey}`,
  flexDirection: "column",
  boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.1)",

  "@media (maxWidth: 768px)": {
    boxShadow: "none",
    borderStyle: "solid",
    borderWidth: 0,
    borderBottomWidth: 1,
    borderColor: greys.borderGrey,
  },
};

export const content: CSSProperties = {
  padding: "10px 20px",
  display: "flex",
  flex: 1,
  flexDirection: "row",
  alignItems: "center",
};

export const logoContainer: CSSProperties = {
  padding: "0 20px",
  marginRight: "auto",
  marginLeft: 0,
  height: "100%",
  display: "flex",
  alignItems: "center",
};

export const logo: CSSProperties = {
  width: 172,
  "@media (maxWidth: 768px)": {
    width: 160,
  },
};

export const btnContainer: CSSProperties = {
  "@media (maxWidth: 700px)": {
    display: "none",
  },
};

export const btnProps = {
  labelStyle: {
    color: colors.green.darker,
    fontWeight: weight.std,
  } as CSSProperties,
};

export const promoButton = {
  container: {
    flex: 1,
    display: "flex",
    justifyContent: "flex-end",
  } as CSSProperties,
  button: {
    display: "inline-block",
    textAlign: "center",
  } as CSSProperties,
};

export const gradientBar: CSSProperties = {
  height: 4,
  width: "100%",
  flexShrink: 0,
  background: gradient,
  display: "none",

  "@media (maxWidth: 768px)": {
    display: "block",
  },
};
